import { render, staticRenderFns } from "./extend.vue?vue&type=template&id=18573e54&scoped=true"
import script from "./extend.vue?vue&type=script&lang=js"
export * from "./extend.vue?vue&type=script&lang=js"
import style0 from "./extend.vue?vue&type=style&index=0&id=18573e54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18573e54",
  null
  
)

export default component.exports